import * as BeisenCloudMobile from './component_index';
var staticPath = window.BSGlobal.staticPath;
__webpack_public_path__ = staticPath;
window['@beisen/beisencloud-mobile'] = BeisenCloudMobile;


// WEBPACK FOOTER //
// ./index.js